import * as React from 'react';
import {
    IconAdminWrapper,
    IconBonusEngineWrapper,
    IconCasinoWrapper,
    IconCMSWrapper,
    IconComplianceWrapper,
    IconReportingWrapper,
    IconTradingWrapper,
} from 'src/components/Header/LHSMenu/MainMenu.style';

export interface LinkType {
    name: string;
    route: string;
    parameters: {};
    icon: JSX.Element;
}

export const defaultLinks: Array<LinkType> = [
    {
        name: 'Trading',
        route: 'global:trading',
        parameters: {},
        icon: <IconTradingWrapper />,
    },
    {
        name: 'Compliance',
        route: 'global:fraud-and-compliance',
        parameters: {},
        icon: <IconComplianceWrapper />,
    },
    {
        name: 'Bet Ticker',
        route: 'global:bet-ticker',
        parameters: {},
        icon: <IconTradingWrapper />, // todo - add icon for bet ticker
    },
    {
        name: 'Reporting',
        route: 'global:reporting',
        parameters: {},
        icon: <IconReportingWrapper />,
    },
    {
        name: 'Admin',
        route: 'global:admin',
        parameters: {},
        icon: <IconAdminWrapper />,
    },
    {
        name: 'CMS',
        route: 'global:cms',
        parameters: {
            tab: 'global',
        },
        icon: <IconCMSWrapper />,
    },
    {
        name: 'Casino',
        route: 'global:casino',
        parameters: {
            'casino-tab': 'casino',
            'casino-view': 'games',
        },
        icon: <IconCasinoWrapper />,
    },
    {
        name: 'Bonus',
        route: 'global:bonus-engine',
        parameters: {
            'bonus-tab': 'campaign-list',
        },
        icon: <IconBonusEngineWrapper />,
    },
];

export const dashboardLink: LinkType = {
    name: 'Dashboard',
    route: 'global:dashboard',
    parameters: {},
    icon: <IconTradingWrapper />, // TODO: ASK DESIGNERS
};

export const cmsV2Link: LinkType = {
    name: 'CMS',
    route: 'global:cmsV2',
    parameters: {
        tab: 'globalV2',
    },
    icon: <IconCMSWrapper />,
};

export const tradingV2Link: LinkType = {
    name: 'Trading',
    route: 'global:tradingV2',
    parameters: {
        tab: 'csv-uploadV2',
    },
    icon: <IconTradingWrapper />,
};

export const betTickerV2Link: LinkType = {
    name: 'Bet Ticker',
    route: 'global:bet-tickerV2',
    parameters: {},
    icon: <IconTradingWrapper />,
};
